
















































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { Owner, SearchCondition } from '@/modules/admin/owner';
import { School } from '@/models/school';
import { ElForm } from 'element-ui/types/form';
import { UserTypes } from '@/enums/userTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import store from '@/store';

Component.registerHooks([
  'beforeRouteEnter',
]);

@Component
export default class OwnerList extends Vue {
  private editVisible = false;
  private isEdit = false;
  private showSearchCondition = true;

  private formRule = {
    lastName: [
      { required: true, message: '氏名（姓）を入力してください' },
    ],
    firstName: [
      { required: true, message: '氏名（名）を入力してください' },
    ],
    lastNameKana: [
      { required: true, message: 'カナ（姓）を入力してください' },
      { pattern: '^[ァ-ヶー]*$', trigger: 'blur', message: '全角カタカナを入力してください' },
    ],
    firstNameKana: [
      { required: true, message: 'カナ（名）を入力してください' },
      { pattern: '^[ァ-ヶー]*$', trigger: 'blur', message: '全角カタカナを入力してください' },
    ],
  };

  private deleteFormRule = {
    checkUserName: [
      { required: true, message: '削除するオーナー名を入力してください' },
      { validator: this.validateCheckUserName, trigger: 'blur' },
    ],
  };

  private validateCheckUserName(rule: any, value: string, callback: any) {
    const userName = ((this.$refs.userDelete as DialogWrapper).form as any).userName;
    if (value.replace(/\s+/g, '') === userName.replace(/\s+/g, '')) {
      callback();
    } else {
      callback(new Error('オーナー名が異なります'));
    }
  }

  get loading(): boolean {
    return this.$store.state.adminOwner.loading;
  }

  get countAll(): number {
    if (this.$store.state.adminOwner.countAll === 0) {
      return 1;
    } else {
    return this.$store.state.adminOwner.countAll;
    }
  }

  get users(): Owner[] {
    return this.$store.state.adminOwner.users;
  }

  get condition(): SearchCondition {
    return this.$store.state.adminOwner.searchCondition;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    switch (store.getters['adminAuth/userType']) {
      case UserTypes.Admin:
        next();
        break;
      default:
        next({ name: 'AdminError' });
        break;
    }
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private loadData() {
    this.$store.dispatch('adminOwner/searchUsers', this.condition);
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = '';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private submitForm() {
    (this.$refs.form as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.userEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onCreate() {
    this.isEdit = false;

    const form: Owner = {
      id: '',
      userId: '',
      lastName: '',
      firstName: '',
      lastNameKana: '',
      firstNameKana: '',
      note: '',
      schoolList: new Array<School>(),
      authority: 0,
      schoolId: '',
      schoolName: '',
      availableFunctionbit: 0,
      availableFunctionTypes: new Array<FunctionTypes>(),
    };

    let result: Owner;
    try {
      result = await (this.$refs.userEdit as DialogWrapper).open({...form}) as Owner;
    } catch (error) {
      return;
    }

    const fullName = this.getFullName(result);
    try {
      const createResult = await this.$store.dispatch('adminOwner/createUser', result);
      createResult.title = 'オーナー登録完了';
      try {
        await (this.$refs.userCreateResult as DialogWrapper).open({...createResult});
      } catch (error) {
        return;
      }
    } catch (error) {
      this.$notify.error({
        title: 'オーナー登録エラー',
        message: error.message,
        position: 'bottom-right'
      });
      return;
    }

    this.loadData();
  }

  private async onEdit(row: Owner) {
    this.isEdit = true;

    let form: Owner;
    try {
      form = await this.$store.dispatch('adminOwner/getUser', row.id);
    } catch (error) {
      form = JSON.parse(JSON.stringify(row));
    }

    let result: Owner;
    try {
      result = await (this.$refs.userEdit as DialogWrapper).open({...form}) as Owner;
    } catch (error) {
      return;
    }

    const fullName = this.getFullName(row);
    try {
      await this.$store.dispatch('adminOwner/editUser', result);
      this.$notify({
        title: 'オーナー変更完了',
        message: `「${fullName}」を変更しました。`,
        position: 'bottom-right',
        type: 'success'
      });
    } catch (error) {
      this.$notify.error({
        title: 'オーナー変更エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private submitDeleteForm() {
    (this.$refs.deleteForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.userDelete as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onDelete(row: Owner) {
    const fullName = this.getFullName(row);

    try {
      const form = {
        userName: fullName,
        checkUserName: '',
      };
      await (this.$refs.userDelete as DialogWrapper).open({...form});
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('adminOwner/deleteUser', row.id);
      this.$notify({
        title: 'オーナー削除完了',
        message: `「${fullName}」を削除しました。`,
        position: 'bottom-right',
        type: 'success'
      });
    } catch (error) {
      this.$notify.error({
        title: 'オーナー削除エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private async onResetPassword(row: Owner) {
    const fullName = this.getFullName(row);
    try {
      await this.$confirm(`「${fullName}」のパスワードを初期化します。よろしいですか？`, 'オーナーパスワード初期化', {
        confirmButtonText: '初期化',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      });
    } catch (error) {
      return;
    }

    try {
      const result = await this.$store.dispatch('adminOwner/resetPassword', row.id);
      result.title = 'パスワード初期化完了';

      try {
        await (this.$refs.userCreateResult as DialogWrapper).open({...result});
      } catch (error) {
        return;
      }
    } catch (error) {
      this.$notify.error({
        title: 'オーナーパスワード初期化エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private getFullName(user: Owner) {
    return `${user.lastName}　${user.firstName}`;
  }
}
